import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import getZoomValues from "./../imports/function_get-zoom-values";

export default (function () {
    $(document).ready(function () {
        var selector = ".chapter-title";

        if ($(selector).length) {
            if (log) console.log("%ccustom_chapter-title.js initialized", "color: green;");
            gsap.registerPlugin(ScrollTrigger);

            $(selector).each(function () {
                var $instance = $(this);
                var $target = $instance.find(".thumbnail");
                var overlay = $instance.find(".overlay")[0];
                var focus = $target.data("focus");
                var scale = $target.data("scale");
                var zoom = getZoomValues(focus, scale);

                if (!focus || !scale) return;

                const [xStr, yStr] = focus.split(",");
                const xPercent = parseFloat(xStr) / 100;
                const yPercent = parseFloat(yStr) / 100;

                gsap.fromTo(
                    $target[0],
                    {
                        x: zoom.x + "%",
                        y: zoom.y + "%",
                        scale: zoom.scale,
                    },
                    {
                        x: "0%",
                        y: "0%",
                        scale: 1,
                        ease: "none",
                        force3D: true,
                        scrollTrigger: {
                            scroller: window,
                            trigger: $instance[0],
                            start: "top top",
                            end: "bottom bottom",
                            scrub: 1,
                        },
                    }
                );

                gsap.to(overlay, {
                    alpha: 0.6,
                    ease: "none",
                    force3D: true,
                    scrollTrigger: {
                        scroller: window,
                        trigger: $instance[0],
                        start: "top top-=100%",
                        end: "bottom bottom",
                        scrub: 1,
                    },
                });

                if (log) {
                    const $dot = $(`<div class="dot"></div>`);

                    $dot.css({
                        position: "absolute",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: "red",
                        left: `${xPercent * 100}%`,
                        top: `${yPercent * 100}%`,
                        transform: "translate3d(-50%, -50%, 0)",
                        pointerEvents: "none",
                        zIndex: 9999,
                    });

                    $target.css("position", "relative").append($dot);
                }
            });
        }
    });
})();
